import { render, staticRenderFns } from "./indexbak2.vue?vue&type=template&id=324e135a&scoped=true&"
import script from "./indexbak2.vue?vue&type=script&lang=js&"
export * from "./indexbak2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e135a",
  null
  
)

export default component.exports